export enum OrderStatusEnum {
  CREATED = 'CREATED',
  IN_APPROVAL = 'IN_APPROVAL',
  IN_PROCESSING = 'IN_PROCESSING',
  IN_ASSEMBLE = 'IN_ASSEMBLE',
  INVOICE = 'INVOICE',
  IN_DELIVERY = 'IN_DELIVERY',
  DELIVERED = 'DELIVERED',
  LOSS = 'LOSS',
}
